// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { mandala as _mandala } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the mandala chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 595
 * Chain Name: Mandala TC9
 * Default Block Explorer: https://blockscout.mandala.aca-staging.network
 * Default RPC URL: https://eth-rpc-tc9.aca-staging.network
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { mandala } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: mandala,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const mandala = createCommon({
	..._mandala,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
